import { API_ROOT } from 'environment';

angular.module('app.resources').factory('SuppressedEmail', ($q, $resource) => $resource(`${API_ROOT}/suppressed_email_addresses/:id`));


// WEBPACK FOOTER //
// ./resources/suppressed_email.js